import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { toast } from "react-hot-toast";
import { connect } from "react-redux";
import {
  setCartStage,
  setShowMobileIstand,
} from "../../redux/actions/cartAction";
import { getWorkshopFilterMap } from "../../redux/actions/apiActions";
import { setLayer } from "redux/actions/globalAction";
import { useState } from "react";
import { MdKeyboardBackspace } from "react-icons/md";
import { IoCloseSharp } from "react-icons/io5";

const Timeline = ({
  cart,
  setCartStage,
  getWorkshopFilterMap,
  globalData,
  setShowMobileIstand,
  setLayer,
}) => {
  let { stage } = cart;
  const [isChecked, setIsChecked] = useState(1);
const router =useRouter()
const isCart = localStorage.getItem("mobileCart")
  const openService = () => {
    if (
      (cart.workshop && cart.products.length) ||
      cart.addedPackages.length > 0
    ) {
      setCartStage(2);
    } else {
      toast.dismiss();
      toast.error("Please select a preferred service provider.");
    }
  };

  const openWorkshop = () => {
    if (cart.workshop || cart.products.length) {
      setCartStage(1);
      getWorkshopFilterMap(
        40,
        1,
        globalData.locationData?.lat,
        globalData.locationData?.lng,
        cart.products[0]?.Id,
        globalData.carData?.modelId,
        "Distance"
      );
    } else {
      // toast.error("Select Product First")
    }
  };

  const openAddons = () => {
    if (cart.workshop && cart.jobItems.length != 0) {
      setCartStage(3);
    } else {
      // toast.error("Select Product First")
    }
  };

  const openCheckout = () => {
    if (cart.workshop && cart.jobItems.length != 0) {
      setCartStage(4);
    }
  };
  useEffect(() => {
    
    const cartJobItems = JSON.parse(
      localStorage.getItem("cart-job-items") ?? JSON.stringify([])
    );
    const cartPackages = JSON.parse(
      localStorage.getItem("cart-packages") ?? JSON.stringify([])
    );
    const cartProduct = JSON.parse(
      localStorage.getItem("cart-product") ?? JSON.stringify([])
    );

    if (
      (cart && stage != 1 && cart.workshop != null && cart.products?.length) ||
      (cartJobItems?.length && cartProduct?.length) ||
      cartPackages?.length
    ) {
      const isCartClear = localStorage.getItem("isCartClear");
      const startOver = localStorage.getItem("startOver");
      if (isCartClear || startOver) {
        localStorage.removeItem("startOver");
        setCartStage(null);
      } else {
        setCartStage(4);
      }
    } else if (stage == 2) {
      return;
    } else if (cart?.products && !cart?.products?.length) {
      setCartStage(null);
    } else {
      setCartStage(1);
    }
  }, []);

  useEffect(() => {
    setIsChecked(cart.stage);
  }, [cart.stage]);
  const isWorkshopCollection = sessionStorage.getItem("isWorkshopCollection");

  return (
    <div className="tab-container-island">
      {stage !== 1 ? (
        <div
          style={{ marginBottom: "1px", marginTop: "-10px" }}
          className="cart-back-btn"
          onClick={() => {
            if (cart.stage > 1) {
              setCartStage(cart.stage - 1);
            }
          }}
        >
          <MdKeyboardBackspace />
          <span style={{ fontSize: "small" }}>
            <strong>BACK</strong>
          </span>
        </div>
      ) : (
        <div
          style={{ marginBottom: "1px", marginTop: "-10px" }}
          className="cart-back-btn"
          onClick={() => {
            setShowMobileIstand(false);
          }}
        >
          <IoCloseSharp />
          <span style={{ fontSize: "small" }}>
            <strong>CLOSE</strong>
          </span>
        </div>
      )}
      <div className="tab-container">
        <ul
          className={
            !isWorkshopCollection ? "island-cs-tabs" : "island-cs-tabs-sv"
          }
        >
          {!isWorkshopCollection ? (
            <li onClick={openWorkshop}>
              <input
                type="radio"
                name="item"
                id={isChecked == 1 ? "checkedone" : "one"}
                checked={isChecked == 1}
              />
              <label
                id={isChecked == 1 ? "checkedfourlable" : ""}
                htmlFor="one"
              >
                <i id={isChecked == 1 ? "checkedfouricon" : ""}>1</i>
                <span>WORKSHOP</span>{" "}
              </label>
            </li>
          ) : null}
          <li onClick={openService}>
            <input
              type="radio"
              name="item"
              id={isChecked == 2 ? "checkedtwo" : "two"}
              checked={isChecked == 2}
            />
            <label id={isChecked == 2 ? "checkedfourlable" : ""} htmlFor="two">
              <i id={isChecked == 2 ? "checkedfouricon" : ""}>
                {isWorkshopCollection ? "1" : "2"}
              </i>
              <span>SERVICE</span>
            </label>
          </li>
          <li onClick={openAddons}>
            <input
              type="radio"
              name="item"
              id={isChecked == 3 ? "checkedthree" : "three"}
              // checked={isChecked == !isWorkshopCollection ? 3 : 2}
              checked={isChecked == 3}
            />
            <label
              id={isChecked == 3 ? "checkedfourlable" : ""}
              htmlFor="three"
            >
              <i id={isChecked == 3 ? "checkedfouricon" : ""}>
                {!isWorkshopCollection ? 3 : 2}
              </i>
              <span>ADDON</span>{" "}
            </label>
          </li>
          <li onClick={openCheckout}>
            <input
              type="radio"
              name="item"
              id={isChecked == 4 ? "checkedfour" : "onefour"}
              // checked={isChecked == !isWorkshopCollection ? 4 : 3}
              checked={isChecked == 4}
            />
            <label id={isChecked == 4 ? "checkedfourlable" : ""} htmlFor="four">
              <i id={isChecked == 4 ? "checkedfouricon" : ""}>
                {!isWorkshopCollection ? 4 : 3}
              </i>
             {isCart? <span>Cart</span>: <span>SUMMARY</span>}
            </label>
          </li>
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    apiData: state.apiData,
    globalData: state.globalData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    getWorkshopFilterMap: (size, page, lat, lang, vId, mId, filter) => {
      dispatch(getWorkshopFilterMap(size, page, lat, lang, vId, mId, filter));
    },
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Timeline);
